<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		height="1em"
		viewBox="0 0 150 200"
	>
		<defs>
			<linearGradient
				id="logo_f"
				y2="203.072"
				x2="97.325"
				y1="197.061"
				x1="94.473"
				gradientTransform="translate(-223.343 -63.977) scale(1.75753)"
				gradientUnits="userSpaceOnUse"
				xlink:href="#logo_a"
			/>
			<linearGradient id="logo_a">
				<stop offset="0" stop-color="#8ae234" />
				<stop offset="1" stop-color="#4e9a06" />
			</linearGradient>
			<linearGradient
				id="logo_g"
				y2="252.588"
				x2="116.783"
				y1="198.703"
				x1="85.672"
				gradientTransform="translate(-223.343 -63.977) scale(1.75753)"
				gradientUnits="userSpaceOnUse"
				xlink:href="#logo_a"
			/>
			<linearGradient
				id="logo_h"
				y2="370.314"
				x2="121.945"
				y1="313.233"
				x1="93.082"
				gradientTransform="matrix(1.66726 0 0 1.62815 -218.051 -225.052)"
				gradientUnits="userSpaceOnUse"
				xlink:href="#logo_b"
			/>
			<linearGradient id="logo_b">
				<stop offset="0" stop-color="#fff" stop-opacity=".549" />
				<stop offset="1" stop-color="#fff" stop-opacity="0" />
			</linearGradient>
			<linearGradient id="logo_c">
				<stop offset="0" stop-color="#fff" />
				<stop offset=".5" stop-color="#fff520" stop-opacity=".891" />
				<stop offset="1" stop-color="#fff300" stop-opacity="0" />
			</linearGradient>
			<filter id="logo_d" height="1.335" y="-.168" width="1.337" x="-.168" color-interpolation-filters="sRGB">
				<feGaussianBlur stdDeviation=".63" />
			</filter>
			<filter id="logo_e" color-interpolation-filters="sRGB"><feGaussianBlur stdDeviation="1.275" /></filter>
			<radialGradient
				id="logo_i"
				xlink:href="#logo_c"
				gradientUnits="userSpaceOnUse"
				cx="55"
				cy="125"
				fx="55"
				fy="125"
				r="14.375"
			/>
		</defs>
		<g transform="translate(93.114 -254.984)">
			<path
				transform="translate(-239.299 129.854) scale(1.75753)"
				d="M100.134 82.972h8.98v9.021h-8.98z"
				fill-rule="evenodd"
				stroke="#000"
				stroke-width="1.651"
				filter="url(#d)"
			/>
			<path
				transform="translate(-239.299 129.854) scale(1.75753)"
				d="M95.888 87.412h62.115a5.405 5.405 0 015.417 5.417v43.72a5.405 5.405 0 01-5.417 5.417H95.888a5.405 5.405 0 01-5.417-5.417V92.83a5.405 5.405 0 015.417-5.417z"
				fill-rule="evenodd"
				stroke="#000"
				stroke-width="2.051"
				filter="url(#e)"
			/>
			<path
				d="M-63.31 275.68h15.782v15.855h-15.781z"
				fill="url(#f)"
				fill-rule="evenodd"
				stroke="#366a04"
				stroke-width="2.902"
			/>
			<path
				d="M-70.772 283.483H38.396a9.5 9.5 0 019.521 9.521v76.84a9.5 9.5 0 01-9.52 9.52h-109.17a9.5 9.5 0 01-9.52-9.52v-76.84a9.5 9.5 0 019.52-9.52z"
				fill="url(#g)"
				fill-rule="evenodd"
				stroke="#366a04"
				stroke-width="3.605"
			/>
			<path
				d="M7.261 331.424c0 12.95-10.498 23.45-23.45 23.45-12.95 0-23.449-10.5-23.449-23.45s10.5-23.45 23.45-23.45 23.45 10.5 23.45 23.45z"
				fill="#fff"
				stroke="#366a04"
				stroke-width="3.605"
			/>
			<path
				d="M-68.185 286.857H35.376c6.761 0 9.032 2.836 9.032 8.82v71.183c0 5.985-2.49 8.82-9.032 8.82h-103.56c-6.762 0-9.033-2.616-9.033-8.82v-71.183c0-6.643 2.93-8.82 9.032-8.82z"
				fill="none"
				stroke="url(#h)"
				stroke-width="3.38"
				stroke-linejoin="round"
			/>
			<circle
				transform="translate(-76.383 64.435) scale(1.72247)"
				style="marker: none"
				cx="55"
				cy="125"
				r="14.375"
				color="#000"
				display="block"
				fill="url(#i)"
			/>
		</g>
		<path
			style="line-height: 125%; -inkscape-font-specification: 'PT Sans Bold'; text-align: start"
			d="M32.617 146.7l5.666 15.941 1.121 5.169h.25l.871-5.231 3.986-15.88h7.41l-9.59 31.448h-5.978l-6.29-17.436-.81-3.923h-.31l-.748 3.985-5.978 17.374h-6.165L6.026 146.7h8.78l4.547 15.63.747 5.542h.311l1.059-5.604 5.169-15.568zm46.808 28.458q-1.869 1.494-5.107 2.553-3.176.996-6.787.996-7.535 0-11.023-4.359-3.487-4.42-3.487-12.08 0-8.22 3.923-12.33 3.923-4.11 11.022-4.11 2.367 0 4.609.623 2.241.622 3.985 2.054 1.744 1.433 2.802 3.861 1.059 2.429 1.059 6.04 0 1.308-.187 2.803-.124 1.495-.436 3.114H61.117q.186 3.923 1.992 5.915 1.868 1.993 5.978 1.993 2.554 0 4.546-.747 2.055-.81 3.114-1.62zm-11.583-22.854q-3.176 0-4.733 1.93-1.494 1.869-1.806 5.045h11.583q.249-3.363-1.059-5.169-1.245-1.806-3.985-1.806zm18.466-18.059h8.096v14.945h.249q1.307-1.494 3.362-2.366 2.055-.872 4.546-.872 5.605 0 8.531 3.861 2.99 3.799 2.99 11.645 0 8.407-4.173 12.766-4.11 4.359-11.333 4.359-3.986 0-7.286-.685-3.3-.623-4.982-1.432zm13.887 18.557q-2.242 0-3.674 1.183-1.37 1.121-2.117 3.3v13.576q.996.498 2.117.685 1.183.187 2.49.187 3.301 0 4.982-2.366 1.744-2.429 1.744-7.66 0-8.905-5.542-8.905zm19.608-6.102h5.916l.934 3.736h.25q1.619-2.366 3.798-3.487 2.242-1.121 5.418-1.121 5.853 0 8.78 3.736 2.927 3.674 2.927 11.894 0 3.986-.934 7.224-.934 3.176-2.802 5.417-1.806 2.242-4.484 3.425-2.615 1.183-6.04 1.183-1.93 0-3.176-.31-1.246-.25-2.491-.873v12.766h-8.096zm13.887 5.978q-2.366 0-3.736 1.183-1.308 1.183-2.055 3.55v12.952q.872.685 1.868 1.12 1.059.375 2.74.375 3.487 0 5.23-2.43 1.744-2.49 1.744-8.157 0-4.11-1.37-6.351-1.37-2.242-4.42-2.242z"
			font-weight="700"
			font-size="62.272"
			font-family="PT Sans"
			letter-spacing=".17"
			word-spacing="0"
			fill="currentColor"
			stroke="#292929"
			stroke-width=".772"
		/>
	</svg>
</template>
